var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton",style:({ width: !_vm.fullWidth ? (_vm.width + "px") : '100%', height:(_vm.height + "px")})},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }